import isStudent from '../is-student';
import currentGradYear from '../current-grad-year';

const gradYearStart = currentGradYear
const gradYearEnd = gradYearStart + 4;
const isActiveGradYear = (gradYear) => gradYear >= gradYearStart && gradYear <= gradYearEnd

export const iseCurrentStudent = (user = {}) => {
    return isStudent(user) && isActiveGradYear(parseInt(user.gradYear))
}